// removed by extract-text-webpack-plugin
module.exports = {"logo-image":"Logo-module__logo-image___2eRT2","link":"Logo-module__link___3WiJ0","left":"Logo-module__left___1QM4a","right":"Logo-module__right___3HYJL","mobile":"Logo-module__mobile___2oxSZ"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Header/Logo/Logo.module.scss
// module id = 173
// module chunks = 0 1